import { isEmpty } from 'lodash';
import { useEffect } from 'react';

const ApplyFilters = ({
    setSearch,
    search,
    submissionSummary,
    setSelectedStaffGroup,
    setSelectedPCNStaffGroup
}) => {
    const filterValues = {};

    const handleTextFilter = question => {
        const domElement = document.querySelector(`#${question.id}`);
        const valueTrimmed = domElement?.value.trim();
        if (valueTrimmed) {
            if (search?.[question.id] && !search[question.id].includes(valueTrimmed)) {
                filterValues[question.id] = search[question.id].concat([valueTrimmed]);
            } else if (isEmpty(search[question.id])) {
                filterValues[question.id] = [valueTrimmed];
            }
        }
        if (domElement) domElement.value = '';
    };

    const handleCheckboxFilter = question => {
        const checkboxes = document.querySelectorAll(`[name='${question.id}']`);
        checkboxes.forEach(box => {
            if (box.checked) {
                filterValues[question.id] = filterValues[question.id] || [];
                if (!filterValues[question.id].includes(box.value)) {
                    filterValues[question.id].push(box.value);
                }
                box.checked = false;
            }
        });
    };

    const setFilterValues = () => {
        submissionSummary.forEach(question => {
            if (question.type === 'text') handleTextFilter(question);
            else if (['radio', 'select', 'status', 'actions'].includes(question.type)) {
                handleCheckboxFilter(question);
            }
        });

        handleCheckboxFilter({ id: 'home-page-staff-group-gp' });
        handleCheckboxFilter({ id: 'staff-role' });
        handleCheckboxFilter({ id: 'home-page-staff-group-pcn' });
    };

    const handleApplyFilter = () => {
        setFilterValues();

        const updatedSearch = { ...search };

        Object.keys(filterValues).forEach(key => {
            if (updatedSearch[key]) {
                updatedSearch[key] = [...new Set([...updatedSearch[key], ...filterValues[key]])];
            } else {
                updatedSearch[key] = filterValues[key];
            }
        });

        setSearch(updatedSearch);
        sessionStorage.setItem('search', JSON.stringify(updatedSearch));

        setSelectedStaffGroup(null);
        setSelectedPCNStaffGroup(null);
    };

    const handleMouseClick = e => {
        e.preventDefault();
        handleApplyFilter();
        e.currentTarget.blur();
    };

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleApplyFilter();
        }
    };

    useEffect(() => {
        const stored = sessionStorage.getItem('search');
        if (stored) setSearch(JSON.parse(stored));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <button
            className="nhsuk-button"
            type="submit"
            onClick={handleMouseClick}
            onKeyPress={handleKeyPress}
        >
            Apply Filters
        </button>
    );
};

export default ApplyFilters;
